import { FormPage } from "../../types/form";

export const page3Config: FormPage = {
  page: 3,
  elements: [
    {
      id: "section_development_info",
      type: "section_header",
      label: "formFields.page3.sectionDevInfo"
    },
    {
      id: "worksheet_search",
      type: "worksheet_search",
      label: "formFields.page3.worksheetSearchLabel",
      name: "worksheet_search",
      targetField: "topic_learned",
      description: "formFields.page3.worksheetSearchDesc"
    },
    {
      id: "document_links",
      type: "document_link",
      label: "formFields.page3.documentLinksLabel",
      name: "document_links",
      description: "formFields.page3.documentLinksDesc"
    },
    {
      id: "topic_learned",
      type: "text",
      label: "formFields.page3.topicLearnedLabel",
      name: "topic_learned",
      required: true
    },
    {
      id: "knowledge_rating",
      type: "radio",
      label: "formFields.page3.knowledgeRatingLabel",
      name: "knowledge_rating",
      required: true,
      description: "formFields.page3.ratingDesc",
      options: [
        { value: 5, label: "formFields.page3.rating5" },
        { value: 4, label: "formFields.page3.rating4" },
        { value: 3, label: "formFields.page3.rating3" },
        { value: 2, label: "formFields.page3.rating2" },
        { value: 1, label: "formFields.page3.rating1" }
      ]
    },
    {
      id: "knowledge_behavior",
      type: "textarea",
      label: "formFields.page3.knowledgeBehaviorLabel",
      name: "knowledge_behavior",
      required: true,
      description: "formFields.page3.behaviorDesc"
    },
    {
      id: "skills_rating",
      type: "radio",
      label: "formFields.page3.skillsRatingLabel",
      name: "skills_rating",
      required: true,
      description: "formFields.page3.ratingDesc",
      options: [
        { value: 5, label: "formFields.page3.rating5" },
        { value: 4, label: "formFields.page3.rating4" },
        { value: 3, label: "formFields.page3.rating3" },
        { value: 2, label: "formFields.page3.rating2" },
        { value: 1, label: "formFields.page3.rating1" }
      ]
    },
    {
      id: "skills_behavior",
      type: "textarea",
      label: "formFields.page3.skillsBehaviorLabel",
      name: "skills_behavior",
      required: true,
      description: "formFields.page3.behaviorDesc"
    },
    {
      id: "attitude_rating",
      type: "radio",
      label: "formFields.page3.attitudeRatingLabel",
      name: "attitude_rating",
      required: true,
      description: "formFields.page3.ratingDesc",
      options: [
        { value: 5, label: "formFields.page3.rating5" },
        { value: 4, label: "formFields.page3.rating4" },
        { value: 3, label: "formFields.page3.rating3" },
        { value: 2, label: "formFields.page3.rating2" },
        { value: 1, label: "formFields.page3.rating1" }
      ]
    },
    {
      id: "attitude_behavior",
      type: "textarea",
      label: "formFields.page3.attitudeBehaviorLabel",
      name: "attitude_behavior",
      required: true,
      description: "formFields.page3.behaviorDesc"
    },
    {
      id: "student_improvement",
      type: "textarea",
      label: "formFields.page3.studentImprovementLabel",
      name: "student_improvement",
      required: true,
      description: "formFields.page3.studentImprovementDesc"
    },
    {
      id: "problems_encountered",
      type: "checkbox",
      label: "formFields.page3.problemsLabel",
      name: "problems_encountered",
      required: true,
      description: "formFields.page3.problemsDesc",
      options: [
        { value: "ตีความโจทย์ผิด / ไม่เข้าใจคำถาม", label: "formFields.page3.problem1" },
        { value: "คำนวณผิดพลาดในขั้นตอนพื้นฐาน", label: "formFields.page3.problem2" },
        { value: "ขาดความมั่นใจในการตอบ", label: "formFields.page3.problem3" },
        { value: "เร่งรีบ ไม่ตรวจสอบคำตอบ", label: "formFields.page3.problem4" },
        { value: "ฟังโจทย์ไม่ละเอียด อ่านจับใจความผิดพลาด", label: "formFields.page3.problem5" },
        { value: "สับสนไวยากรณ์หรือโครงสร้างภาษา", label: "formFields.page3.problem6" },
        { value: "สมาธิสั้น มีสิ่งรบกวนระหว่างเรียน", label: "formFields.page3.problem7" },
        { value: "Other", label: "formFields.page3.problemOther", hasTextInput: true, textInputName: "problems_encountered_other" }
      ]
    },
    {
      id: "solutions_applied",
      type: "checkbox",
      label: "formFields.page3.solutionsLabel",
      name: "solutions_applied",
      required: true,
      description: "formFields.page3.solutionsDesc",
      options: [
        { value: "อธิบายซ้ำโดยใช้วิธีอื่น", label: "formFields.page3.solution1" },
        { value: "ให้ทำแบบฝึกหัดเพิ่มเติม", label: "formFields.page3.solution2" },
        { value: "ใช้คำถามปลายเปิด", label: "formFields.page3.solution3" },
        { value: "ให้ทำโจทย์แบบมีลำดับขั้น", label: "formFields.page3.solution4" },
        { value: "อธิบายความเชื่อมโยงกับวิชาอื่น", label: "formFields.page3.solution5" },
        { value: "Other", label: "formFields.page3.solutionOther", hasTextInput: true, textInputName: "solutions_applied_other" }
      ]
    },
    {
      id: "homework",
      type: "textarea",
      label: "formFields.page3.homeworkLabel",
      name: "homework_assigned",
      required: true
    },
    {
      id: "next_topic_worksheet_search",
      type: "worksheet_search",
      label: "formFields.page3.nextTopicSearchLabel",
      name: "next_topic_worksheet_search",
      targetField: "next_topic",
      description: "formFields.page3.nextTopicSearchDesc"
    },
    {
      id: "next_topic",
      type: "textarea",
      label: "formFields.page3.nextTopicLabel",
      name: "next_topic",
      required: true
    }
  ]
};
